export default {
  perPage: 'per page',
  numberOfRecords: 'Showing {start} - {end} of {numberOfRecords} records',
  of: 'of {numberOfPages}',
};
